export default [
  {
    name: 'project_tab_navigation',
    component_path: 'modules/templates/blocks/project/ProjectNavigation',
  }
]